import { styled } from '@mui/material/styles';
import { SvgIcon } from '@mui/material';
import { DS_typography as coreTypography } from 'mui/base/theme/DS_Tokens/core';
import searchIcon from 'assets/icons/search.svg';

export const StyledInputContainer = styled('div')(
  ({ theme }) => `
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 250px;
    z-index: 1;
    margin-top: 8px;
    padding: 6px 12px 6px 16px;
    border-radius: 12px;
    border: 1px solid #E3E3E3;
    background: ${theme.DS_palette.primary.white};

    position: relative;
    overflow: hidden;
    
    .localities-input-wrapper, .localities-input-container {
      width: 100%;
    }
    
    ${theme.breakpoints.up('lg')} {
      width: 95%;
      margin: auto;
      right: 12px;
      left: 12px;
      top: 12px;
    }
  `,
);

export const StyledSearchIcon = styled('div')`
  position: absolute;
  right: 0;
  bottom: 0;
  border: none;
  background: none;
  width: 40px;
  height: 100%;
  background-image: url(${searchIcon});
  background-repeat: no-repeat;
  background-size: 16px;
  background-position: center 14px;
`;

export const StyledSvgIcon = styled(SvgIcon)(
  () => `
    fill: none;
    margin-right: 12px;
  `,
);

export const StyledInput = styled('input')(
  ({ theme }) => `
    width: 100%;
    border: 0 !important;
    height: auto !important;
    padding: 6px 0 !important;
    font-size: ${coreTypography.fontSize.root};
    font-weight: ${coreTypography.fontWeight.medium};
    line-height: ${coreTypography.lineHeight.lvl5};
    background: ${theme.DS_palette.primary.white} !important;
    
    ${theme.breakpoints.up('lg')} {
      font-size: coreTypography.fontSize.lvl4;
      line-height: coreTypography.lineHeight.lvl8;
    }
  `,
);

export const StyledLoaderWrapper = styled('div')(
  ({ theme }) => `
    position: absolute;
    bottom: 0px;
    width: 100%;
    left: 0px;
    z-index: 3;
  
    .MuiLinearProgress-root {
      height: 5px;
    }
    .MuiLinearProgress-colorPrimary {
      background-color: ${theme.DS_palette.background.lightBlue};
    }
    .MuiLinearProgress-barColorPrimary {
      background-color: ${theme.DS_palette.buttons.enabled};
    }
  `,
);

export const StyledInputLoaderOverlay = styled('div')(
  ({ theme }) => `
    width: 100%;
    position: absolute;
    border-radius: 12px;
    z-index: 2;
    height: 100%;
    left: 0;
      
    &::before {
      content: "";
      background-color: ${theme.DS_palette.background.lightgrey};
      opacity: 0.3;
      width: 100%;
      position: absolute;
      border-radius: inherit;
      top: 0;
      height: 100%;
    }
  `,
);
